/** @file Shell key bindings (global context); collected into bindings.gen.ts by pnpm gen. */
import type { Binding } from '@pose2d/shortcuts/types';

/** Mod+Comma opens Settings (common editor convention; not a reserved browser chord). */
export const bindings: Binding[] = [{ id: 'shell.openSettings', keys: 'Mod+Comma', context: 'global' }];
